import dynamic from "next/dynamic";

export const DynamicContent055 = dynamic(() => import("./Content055"), {
  suspense: true,
});
